"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailSourceSchema = void 0;
var zod_1 = require("zod");
exports.ThumbnailSourceSchema = zod_1.z.object({
    id: zod_1.z.string(),
    format: zod_1.z.union([zod_1.z.literal('vtt'), zod_1.z.string()]),
    url: zod_1.z.string(),
});
//# sourceMappingURL=thumbnail-source.js.map